import CartItemErrorComponent from './cart-item-error';
import { useFormat } from '../../../../helpers/hooks/useFormat';
import { CartItemError } from '../../cart/errors/CartItemError';
import { CartError as BaseError } from '../errors/CartError';

export interface Props {
  readonly error: BaseError;
  readonly includeErrorMessage?: boolean;
  readonly errorMap?: Record<string, string>;
}

const CartError = ({ error, errorMap, includeErrorMessage }: Props) => {
  const { formatMessage } = useFormat({ name: 'cart' });

  if (error instanceof CartItemError) {
    return <CartItemErrorComponent error={error} />;
  }

  let errorId = !error.code
    ? undefined
    : error.code
        .toString()
        .toLowerCase()
        .replace('_error', '')
        .replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('_', '').replace('-', ''));

  if (errorMap?.[errorId]) {
    errorId = errorMap?.[errorId];
  }

  const title = formatMessage({
    id: `cart.error.${!errorId ? '' : `${errorId}.`}title`,
    defaultMessage: formatMessage({ id: 'cart.error.title', defaultMessage: 'Error processing cart' }),
  });

  const message = formatMessage({
    id: `cart.error.${!errorId ? '' : `${errorId}.`}description`,
    defaultMessage: formatMessage({
      id: 'cart.error.description',
      defaultMessage: 'Something went wrong while processing your cart',
    }),
  });

  return (
    <section aria-labelledby="cart-error" className="flex-auto overflow-y-auto px-0 pb-4 pt-0">
      <div className="border-y border-red-500 bg-red-100 px-4 py-3 text-red-700" role="alert">
        <div>
          <span className="font-bold">{title}</span>
        </div>
        <div className="pt-2 text-sm">
          <span>{message}</span>
        </div>
        {includeErrorMessage && error.message && (
          <div className="pt-2 text-sm">
            <span className="font-bold">{formatMessage({ id: `cart.error.label`, defaultMessage: 'Error' })}:</span>{' '}
            {error.message}
          </div>
        )}
      </div>
    </section>
  );
};

export default CartError;
